(function autoSubmit() {
    $('.auto-submit').change(function () {
        var form = $(this).closest('form');
        $(form).submit();
    });
})();